'use client';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/navigation';
import { UserAuth } from '@/app/context/AuthContext';
import {
	followActions,
	followSelectors,
} from '@/redux/reducers/follow.reducer';

const FollowButton = ({ brandId, className = '' }) => {
	const dispatch = useDispatch();
	const router = useRouter();
	const { user, isPro } = UserAuth();
	const isFollowing = useSelector((s) => followSelectors.isFollowing(s, brandId));

	const handleClick = () => {
		if (!isPro) {
			router.push('/pro');
			return;
		}
		dispatch(followActions.toggleFollow(user.uid, brandId));
	};

	// Figma: Follow = gold fill; Following = white fill with a 1px #020314
	// border. Both use a 10px radius.
	const baseBtn =
		'rounded-[10px] px-6 py-2 text-sm font-normal transition-colors';
	const followStyle = `${baseBtn} bg-[#FACC15] text-black hover:bg-[#eab308]`;
	const followingStyle = `${baseBtn} bg-white text-[#020314] border border-[#020314] hover:bg-gray-50`;

	return (
		<button
			onClick={handleClick}
			className={`${isFollowing ? followingStyle : followStyle} ${className}`}
			aria-pressed={isFollowing}
		>
			{isFollowing ? 'Following' : 'Follow'}
		</button>
	);
};

export default FollowButton;
